package com.neurobs.js.dom

import com.neurobs.js.view
import com.neurobs.js.view.{Container, Form, Gui, ResourcePaths, SoundView}
import org.scalajs.dom.raw.Element
import com.neurobs.js.dom.ElementFactory._
import scalatags.JsDom.all._

import scala.concurrent.{Future, Promise}

class DOMResourcePaths(imageFolder: String) extends ResourcePaths {
	override def getImagePath(localPath: String): String = s"$imageFolder/$localPath"
}

class DOMGui (mainElement: Element, override val sounds: SoundView, imageFolder: String) extends view.Gui {
	import DOMViewElement._

	private val modalDiv = new ModalViewDiv

	override val main: view.Container = {
		mainElement.appendChild(modalDiv.element)
		modalDiv.clientElement
	}

	override val modal: view.ModalView = modalDiv

	override def setCursor(t: Gui.CursorType.Value): Unit = {
		modalDiv.clientElement.style.cursor = t match {
			case Gui.CursorType.Progress => "progress"
			case _ => "auto"
		}
	}

	override def resourcePaths: ResourcePaths = new DOMResourcePaths(imageFolder)

	override def makeMessageBox(width: Int, title: String, description: String, buttonCaptions: Seq[(String, view.MessageBoxResult.Value)], customContent: Option[view.Container] = None): view.MessageBox = {
		val c = customContent.flatMap {
			case ElementContainer(e) => Some(e)
			case _ => None
		}
		ElementFactory.makeMessageDialog(width, title, description, buttonCaptions, c)
	}

	override def makeFormattedText(content: String): Container = {
		pre(style := "text-align: left; white-space: pre-wrap;", content).render
	}

	override def promptSingleValue[A](title: String = "", description: String = "", prompt: String, validate: (String) => Either[String, A], allowCancel: Boolean = true): Future[Option[A]] = {
		val boxWidth = 20
		val formWidth = 40

		val valueBox: InputTextBox = makeTextInput(boxWidth)
		val form = makeForm(
			width = formWidth,
			title = title,
			description = description,
			elements = Array((s"$prompt:", valueBox.text)),
			useCancel = allowCancel,
			submitCaption = "Continue"
		)

		val result = Promise[Option[A]]
		def process(callback: (Option[String]) => Unit): Either[String, Form.Process] = {
			val value = valueBox.value()
			validate(value) match {
				case Left(error) => Left(error)
				case Right(a) =>
					result.success(Some(a))
					callback(None)
					Right(() => Unit)
			}
		}

		showModalForm(form, process, processCancellable = false, formCancel = Some(() => result.success(None)))

		result.future
	}
}
